import { createFileRoute } from "@tanstack/react-router";
import { SupplierModals } from "@/components/supplier/supplier-modals";
import SupplierTable from "@/components/supplier/supplier-table";
import { Button } from "@/components/ui/button";
import { useTranslate } from "@/hooks/use-translate";
import useAppStore from "@/store";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/(dasboard)/products/suppliers")({
  component: SuppliersPage,
});

function SuppliersPage() {
  const store = useAppStore();
  const { t } = useTranslate();
  return (
    <>
      <div className="max-w-6xl mx-auto">
        <SupplierModals />
        <header className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-semibold"> {t("Suppliers")} </h2>
          <Button
            onClick={() => {
              store.display.show("create_supplier");
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Add a supplier")}
          </Button>
        </header>
        <SupplierTable />
      </div>
    </>
  );
}
